import * as React from "react";
import { siteUrl } from "@api";

// <link rel="canonical"> voor de webversie: altijd het hoofddomein met het
// huidige pad, zonder query. Zo telt Google bio.degroteverleiding.nl/nieuw/...
// (dat Caddy al met een 301 doorstuurt) en varianten met ?crumb=... als één
// pagina. De navigatie wisselt van URL via history.pushState/replaceState;
// daar is geen event voor, dus die worden hier omwikkeld.
function setCanonical() {
  let link = document.querySelector<HTMLLinkElement>('link[rel="canonical"]');
  if (!link) {
    link = document.createElement("link");
    link.rel = "canonical";
    document.head.appendChild(link);
  }
  const href = siteUrl + window.location.pathname;
  if (link.href !== href) {
    link.href = href;
  }
}

export default function CanonicalLink(): null {
  React.useEffect(() => {
    const history = window.history;
    const pushState = history.pushState;
    const replaceState = history.replaceState;
    history.pushState = function (...args: Parameters<History["pushState"]>) {
      pushState.apply(history, args);
      setCanonical();
    };
    history.replaceState = function (...args: Parameters<History["replaceState"]>) {
      replaceState.apply(history, args);
      setCanonical();
    };
    window.addEventListener("popstate", setCanonical);
    setCanonical();
    return () => {
      history.pushState = pushState;
      history.replaceState = replaceState;
      window.removeEventListener("popstate", setCanonical);
    };
  }, []);
  return null;
}
